<div class="dropdown d-inline-block">
  <a class="link" href="javascript:void(0)">
    {{textFromSelect}} <i class="fa fa-chevron-down"></i>
  </a>
  <ul class="droplist" name="school">
    <li *ngFor='let item of schools' (click)="clickEvent(item.key)"><a href="#">{{item.value}}</a>
    </li>
  </ul>
</div>
